import { Component } from '@angular/core';
import { FormGroup, FormBuilder, NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OfferedService } from 'src/shared/api';
import { offeredServiceFormConfig } from 'src/shared/form-models/offered-service/offered-service.component';
import { filter } from 'rxjs/operators';
import { OfferedServiceDialogComponent } from 'src/shared/form-models/offered-service/offered-service-dialog/offered-service-dialog.component';
import { animateList } from 'src/shared/animations';
import { CustomFormListAccessor } from 'src/shared/form-models/form-list-cva.component';

@Component({
	selector: 'rpfsa-offered-services-list',
	templateUrl: './offered-services-list.component.html',
	animations: [animateList],
})
export class OfferedServicesListComponent extends CustomFormListAccessor<
	OfferedService
> {
	emptyColumns = ['empty'];
	resultColumns = ['name', 'type', 'status', 'edit'];

	constructor(
		public ngControl: NgControl,
		public fb: FormBuilder,
		private readonly dialog: MatDialog
	) {
		super(ngControl, fb, offeredServiceFormConfig);
	}

	addService() {
		this.dialog
			.open<OfferedServiceDialogComponent, never, FormGroup>(
				OfferedServiceDialogComponent,
				{ width: '450px' }
			)
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.insert(0, control);
			});
	}

	editService(service: OfferedService) {
		this.dialog
			.open<OfferedServiceDialogComponent, OfferedService, FormGroup>(
				OfferedServiceDialogComponent,
				{
					width: '450px',
					data: service,
				}
			)
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.setControl(this.findServiceIndex(service), control);
			});
	}

	findServiceIndex(service: OfferedService){
		return this.dataSource.data.findIndex(s => s === service);
	}
}
